'use strict';
import Config from 'conf';

let translator = null;
let default_locale = Config.default_locale;
let default_sublocale = default_locale.split('_')[0];
let current_locale = default_locale;
let current_sublocale = default_sublocale;
let current_lang = null;
let initialized = false;
let tb_report_term_undefined = {};
const moment = require('moment');

let getObjPath = function(obj, prop, val) {
    if (typeof obj[prop] === 'string') return obj[prop];

    prop = prop === null ? 'noMessage' : prop;
    let props = prop.split('.');
    let final = props.pop();
    let p;
    while ((p = props.shift())) {
        if (typeof obj[p] === 'undefined') return undefined;
        obj = obj[p];
    }
    return val ? (obj[final] = val) : obj[final];
};

let languages_require = {
    fr: () => {
        return {
            lang: require('./langs/fr_FR/translations.json'),
            moment: () => {
                let moment_locale = require('moment/locale/fr');
                moment.updateLocale('fr', moment_locale);
            }
        };
    },
    de: () => {
        return {
            lang: require('./langs/de_DE/translations.json'),
            moment: () => {
                let moment_locale = require('moment/locale/de');
                moment.updateLocale('de', moment_locale);
            }
        };
    }
};

const get_translator = function() {
    if (!translator) {
        translator = new Translator();
    }
    return translator;
};

function Translator() {
    this.set_locale(default_locale);
}

Translator.prototype.set_locale = function(_locale) {
    try {
        _locale = _locale.replace(/\-/, '_');
        if (_locale === current_locale && initialized) return false;

        const _sublocale = _locale.split('_')[0];
        let language = languages_require[default_sublocale]();
        if (typeof languages_require[_sublocale] !== 'undefined') {
            language = languages_require[_sublocale]();
        }
        current_lang = language.lang;
        language.moment();
        current_locale = _locale;
        current_sublocale = _sublocale;
    } catch (e) {
        console.error('An issue has been catch with locale ' + _locale);
        console.warn(e);
    }
    initialized = true;
};

Translator.prototype.isTranslationExist = function(term) {
    if (/\s/g.test(term)) {
        term = this.slugify(term);
    }
    return typeof getObjPath(current_lang, term) === 'string';
};

Translator.prototype.translateWithFallback = function() {
    const args = arguments;
    let argsTranslate = JSON.parse(JSON.stringify(args));
    let argsFallback = JSON.parse(JSON.stringify(args));
    delete argsTranslate[1];
    delete argsFallback[0];

    if (this.isTranslationExist(args[0])) return this.translate.apply(this, Object.values(argsTranslate));
    else return this.translate.apply(this, Object.values(argsFallback));
};

Translator.prototype.translate = function() {
    const args = arguments;
    let term = args[0];
    let slugified_term = this.slugify(args[0]);

    //Si le string ni le string "slugifié" ne sont pas trouvé dans le fichier de traduction
    if (typeof getObjPath(current_lang, term) !== 'string' && typeof getObjPath(current_lang, slugified_term) !== 'string') {
        if (!__DEV__) {
            if (typeof tb_report_term_undefined[current_lang] === 'undefined') {
                tb_report_term_undefined[current_lang] = {};
            }

            if (typeof getObjPath(tb_report_term_undefined[current_lang], term) !== 'string') {
                tb_report_term_undefined[current_lang][term] = true;
            }
        } else {
            if (slugified_term !== term) {
                console.debug('[TRANSLATE] TERM MISSING ' + '[' + current_locale + ']', '-->', slugified_term, '<--', term);
            } else {
                console.debug('[TRANSLATE] TERM MISSING ' + '[' + current_locale + ']', '-->', slugified_term);
            }
        }
        if (typeof getObjPath(languages_require[default_sublocale]().lang, term) === 'string') {
            return getObjPath(languages_require[default_sublocale]().lang, term).replace(/{(\d+)}/g, function(match, number) {
                return typeof args[parseInt(number) + 1] !== 'undefined' ? args[parseInt(number) + 1] : match;
            });
        } else if (typeof getObjPath(languages_require[default_sublocale]().lang, slugified_term) === 'string') {
            return getObjPath(languages_require[default_sublocale]().lang, slugified_term).replace(/{(\d+)}/g, function(match, number) {
                return typeof args[parseInt(number) + 1] !== 'undefined' ? args[parseInt(number) + 1] : match;
            });
        } else if (typeof getObjPath(languages_require[default_sublocale]().lang, term) !== 'string') {
            return __DEV__ ? '[ToTranslate] ' + term : term;
        }
    }
    //Si le string est trouvé dans le fichier de traduction
    else if (typeof getObjPath(current_lang, term) === 'string') {
        return getObjPath(current_lang, term).replace(/{(\d+)}/g, function(match, number) {
            return typeof args[parseInt(number) + 1] !== 'undefined' ? args[parseInt(number) + 1] : match;
        });
    }
    //Si le string "slugifié" est trouvé dans le fichier de traduction
    else if (typeof getObjPath(current_lang, slugified_term) === 'string') {
        return getObjPath(current_lang, slugified_term).replace(/{(\d+)}/g, function(match, number) {
            return typeof args[parseInt(number) + 1] !== 'undefined' ? args[parseInt(number) + 1] : match;
        });
    }
};

Translator.prototype.slugify = function(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '_') // Replace spaces with -
        .replace(/[^\w_.]+/g, '') // Remove all non_word chars
        .replace(/__+/g, '_') // Replace multiple _ with single _
        .replace(/^_+/, '') // Trim - from start of text
        .replace(/_+$/, ''); // Trim - from end of text
};

Translator.prototype.dotize = function(_locale = default_locale) {
    let self = this;
    const _sublocale = _locale.split('_')[0];
    let language = languages_require[_sublocale]();
    let res = {};
    (function recurse(obj, current) {
        for (let key in obj) {
            let value = obj[key];

            let newKey = current ? current + '.' + self.slugify(key) : self.slugify(key); // joined key with dot
            if (value && typeof value === 'object') {
                recurse(value, newKey); // it's a nested object, so do it again
            } else {
                res[newKey] = value; // it's not an object, so set the property
            }
        }
    })(language.lang);
    return JSON.stringify(res); // convert result to JSON
};

Translator.prototype.get_missing_keys = function(object_ref, object_to_compare) {
    let object_diff = {};
    Object.keys(object_ref).map(key => {
        if (typeof object_to_compare[key] === 'undefined' || !object_to_compare[key]) object_diff[key] = object_ref[key];
    });
    return JSON.stringify(object_diff);
};

module.exports = get_translator();



// WEBPACK FOOTER //
// C:/FHE/Support/support-react-application/translator/index.js